import MadeHands from '@/services/five-card-hands/categories/MadeHands';
import Draws from '@/services/five-card-hands/categories/Draws';
import Combos from '@/services/five-card-hands/categories/Combos';
import _ from 'lodash';

export default class FiveCardHands {
  constructor() {
    this.madeHands = new MadeHands();
    this.draws = new Draws();
    this.combos = new Combos();
  };

  get checkedHands() {
    return {
      ...this.checkedMadeHands,
      ...this.checkedDraws,
      ...this.checkedCombos,
    };
  };
  get checkedMadeHands() {
    let checkedMadeHands = {};

    this.madeHands.forEachLeaf(function (madeHandLeaf) {
      if (madeHandLeaf.visible && madeHandLeaf.checked) {
        checkedMadeHands[madeHandLeaf.id] = madeHandLeaf;
      }
    });

    return checkedMadeHands;
  };
  get checkedDraws() {
    let checkedDraws = {};

    this.draws.forEachLeaf(function (drawLeaf) {
      if (drawLeaf.visible && drawLeaf.checked) {
        checkedDraws[drawLeaf.id] = drawLeaf;
      }
    });

    return checkedDraws;
  };
  get checkedCombos() {
    let checkedCombos = {};

    this.combos.forEachLeaf(function (comboLeaf) {
      if (comboLeaf.visible && comboLeaf.checked) {
        checkedCombos[comboLeaf.id] = comboLeaf;
      }
    });

    return checkedCombos;
  };
  get anyCheckedDraws() {
    return !_.isEmpty(this.checkedDraws);
  };
  get anyCheckedCombos() {
    return !_.isEmpty(this.checkedCombos);
  };

  get visibleMadeHands() {
    let visibleMadeHands = [];

    this.forEachVisibleNode(this.madeHands.data, 0, function (node, level) {
      node.level = level
      visibleMadeHands.push(node);
    });

    return visibleMadeHands;
  };
  get shortDeckVisibleMadeHands() {
    let order = [
      'fourOfAKindPlus',
      'fourOfAKindPlus:royalFlush',
      'fourOfAKindPlus:straightFlush',
      'fourOfAKindPlus:fourOfAKind',
      'flush',
      'flush:nut',
      'flush:secondNut',
      'flush:thirdNut',
      'flush:weak',
      'fullHouse',
      'straight',
      'threeOfAKind',
      'threeOfAKind:topSet',
      'threeOfAKind:secondSet',
      'threeOfAKind:thirdSet',
      'threeOfAKind:fourthSet',
      'threeOfAKind:middleSet',
      'threeOfAKind:bottomSet',
      'threeOfAKind:trips',
      'twoPair',
      'twoPair:usingTopBoardCard',
      'twoPair:weak',
      'pair',
      'pair:overpair',
      'pair:tptk',
      'pair:tpgk',
      'pair:tpwk',
      'pair:ppUnderTp',
      'pair:secondPair',
      'pair:middlePair',
      'pair:weakPair',
      'usingABoardCard',
      'usingABoardCard:flushUsingOneHoleCard',
      'usingABoardCard:flushUsingOneHoleCard:nut',
      'usingABoardCard:flushUsingOneHoleCard:secondNut',
      'usingABoardCard:flushUsingOneHoleCard:thirdNut',
      'usingABoardCard:flushUsingOneHoleCard:weak',
      'usingABoardCard:flushOnBoard',
      'usingABoardCard:threeOfAKindOnBoard',
      'usingABoardCard:twoPairWithPairOnBoard',
      'usingABoardCard:twoPairOnBoard',
      'usingABoardCard:pairOnBoard',
      'highCard',
      'highCard:aceHigh',
      'highCard:kingHigh',
      'highCard:weak',
    ];

    return this.visibleMadeHands.sort(function (a, b) {
      return order.indexOf(a.id) - order.indexOf(b.id);
    });
  };
  get visibleDraws() {
    let visibleDraws = [];

    this.forEachVisibleNode(this.draws.data, 0, function (node, level) {
      node.level = level
      visibleDraws.push(node);
    });

    return visibleDraws;
  };
  get visibleCombos() {
    let visibleCombos = [];

    this.forEachVisibleNode(this.combos.data, 0, function (node, level) {
      node.level = level
      visibleCombos.push(node);
    });

    return visibleCombos;
  };

  get flatArrayOfLeaves() {
    let flatArrayOfLeaves = [];

    this.madeHands.flatArrayOfLeaves.forEach(function (leaf) {
      flatArrayOfLeaves.push(leaf);
    });
    this.draws.flatArrayOfLeaves.forEach(function (leaf) {
      flatArrayOfLeaves.push(leaf);
    });
    this.combos.flatArrayOfLeaves.forEach(function (leaf) {
      flatArrayOfLeaves.push(leaf);
    });

    return flatArrayOfLeaves;
  };
  get flatArrayOfParents() {
    let flatArrayOfParents = [];

    this.madeHands.flatArrayOfParents.forEach(function (parent) {
      flatArrayOfParents.push(parent);
    });
    this.draws.flatArrayOfParents.forEach(function (parent) {
      flatArrayOfParents.push(parent);
    });
    this.combos.flatArrayOfParents.forEach(function (parent) {
      flatArrayOfParents.push(parent);
    });

    return flatArrayOfParents;
  };

  get defaultIncludedByDefault() {
    let defaultIncludedByDefault = {};

    this.flatArrayOfLeaves.forEach(function (leaf) {
      defaultIncludedByDefault[leaf.id] = true;
    });

    return defaultIncludedByDefault;
  };
  get defaultCollapsedByDefault() {
    let defaultCollapsedByDefault = {};

    this.flatArrayOfParents.forEach(function (parent) {
      if (parent.id === 'pair') {
        defaultCollapsedByDefault[parent.id] = false;
      } else {
        defaultCollapsedByDefault[parent.id] = true;
      }
    });

    return defaultCollapsedByDefault;
  };

  forEachNode(cb) {
    this.madeHands.forEachNode(cb);
    this.draws.forEachNode(cb);
    this.combos.forEachNode(cb);
  };
  forEachVisibleNode(arr, level, cb) {
    arr.forEach(function (el) {
      if (el.visible) {
        cb(el, level);

        if (el.children && !el.collapsed) {
          this.forEachVisibleNode(el.children, level + 1, cb);
        }
      }
    }, this);
  };
  forEachLeaf(cb) {
    this.madeHands.forEachLeaf(cb);
    this.draws.forEachLeaf(cb);
    this.combos.forEachLeaf(cb);
  };
  forEachParent(cb) {
    this.madeHands.forEachParent(cb);
    this.draws.forEachParent(cb);
    this.combos.forEachParent(cb);
  };
  forEachVisibleLeaf(cb) {
    this.madeHands.forEachVisibleLeaf(cb);
    this.draws.forEachVisibleLeaf(cb);
    this.combos.forEachVisibleLeaf(cb);
  };
  forEachFromNodeInList(listOfFiveCardHandIds, cb) {
    this.forEachNode(function (node) {
      if (listOfFiveCardHandIds.includes(node.id)) {
        cb(node);
      }
    });
  };
  forEachVisibleNodeInList(listOfFiveCardHandIds, cb) {
    this.forEachFromNodeInList(listOfFiveCardHandIds, function (node) {
      if (node.visible) {
        cb(node);
      }
    });
  };

  find(id) {
    let fiveCardHand;

    this.forEachNode(function (node) {
      if (node.id === id) {
        fiveCardHand = node;
      }
    });

    return fiveCardHand;
  };
  uncheckAllVisibleFiveCardHands() {
    this.forEachVisibleLeaf(function (fiveCardHand) {
      fiveCardHand.checked = false;
    });
  };
  checkAllVisibleFiveCardHands() {
    this.forEachVisibleLeaf(function (fiveCardHand) {
      fiveCardHand.checked = true;
    });
  };
  setChecksAccordingToUserDefinedFilters(filterName, userDefinedFilters) {
    let self = this;

    self.forEachVisibleLeaf(function (fiveCardHand) {
      let isPartOfUserDefinedFilter = self._isPartOfUserDefinedFilter(fiveCardHand, filterName, userDefinedFilters);

      if (isPartOfUserDefinedFilter) {
        fiveCardHand.checked = true;
      } else {
        fiveCardHand.checked = false;
      }
    });
  };
  _isPartOfUserDefinedFilter(fiveCardHand, filterName, userDefinedFilters) {
    let fiveCardHandsThatAreCheckedForUserDefinedFilter = _.find(userDefinedFilters, function (userDefinedFilter) {
      return userDefinedFilter.name === filterName;
    }).fiveCardHands;

    if (fiveCardHand.madeHandDrawOrCombo === 'made hand') {
      return fiveCardHandsThatAreCheckedForUserDefinedFilter.madeHands.includes(fiveCardHand.id);
    } else if (fiveCardHand.madeHandDrawOrCombo === 'draw') {
      return fiveCardHandsThatAreCheckedForUserDefinedFilter.draws.includes(fiveCardHand.id);
    } else if (fiveCardHand.madeHandDrawOrCombo === 'combo') {
      return fiveCardHandsThatAreCheckedForUserDefinedFilter.combos.includes(fiveCardHand.id);
    }
  };
  setChecksToDefaults(fiveCardHandsThatAreCheckedByDefault, playerStateName) {
    this.forEachVisibleLeaf(function (fiveCardHand) {
      fiveCardHand.checked = fiveCardHand.getDefaultCheckedValue(fiveCardHandsThatAreCheckedByDefault, playerStateName);
    });
  };
  setCollapsedValuesToDefaults(settings) {
    let self = this;

    _.each(settings.hitCalculator.collapsedByDefault, function (collapsedByDefault, id) {
      self.find(id).collapsed = collapsedByDefault;
    });
  };
  setIncludedValuesToDefaults(settings) {
    let self = this;

    _.each(settings.hitCalculator.includedByDefault, function (includedByDefault, id) {
      self.find(id).included = includedByDefault;
    });
  };
  setProbabilities(handAndDrawInfo, numberOfSimulations) {
    this._setCounts(handAndDrawInfo);
    this._setProbabilitiesGivenCounts(numberOfSimulations);
    this._resetCounts();
  };
  _setCounts(handAndDrawInfo) {
    this.forEachNode(function (node) {
      handAndDrawInfo.forEach(function ({ handInfo, drawInfo }) {
        drawInfo = drawInfo || {};

        if (node.isAHit(handInfo, drawInfo)) {
          node.count++;
        }
      });
    });
  };
  _setProbabilitiesGivenCounts(numberOfSimulations) {
    this.forEachNode(function (node) {
      node._probability = ((node.count / numberOfSimulations) * 100).roundToTwoDecimalPlaces();
    });
  };
  _resetCounts() {
    this.forEachNode(function (node) {
      node.count = 0;
    });
  };
  setMatchingSpecificHands(generalHands, presetCommunityCardsArray, shortDeck) {
    this.madeHands.setMatchingSpecificHands(generalHands, presetCommunityCardsArray, shortDeck);

    if (presetCommunityCardsArray.length < 5) {
      this.draws.setMatchingSpecificHands(generalHands, presetCommunityCardsArray, shortDeck);
      this.combos.setMatchingSpecificHands(generalHands, presetCommunityCardsArray, shortDeck);
    }
  };
  clearMatchingSpecificHands() {
    this.forEachLeaf(function (fiveCardHandLeaf) {
      fiveCardHandLeaf.matchingSpecificHands = [];
    });
  };
  setProbabilitiesAccordingToMatchingSpecificHands(generalHands) {
    this.forEachNode(function (fiveCardHand) {
      fiveCardHand.setProbabilityAccordingToMatchingSpecificHands(generalHands);
    });
  };
  setPercentagesOfSpecificHandsThatAreSelected(generalHands) {
    this.forEachNode(function (fiveCardHand) {
      fiveCardHand.setPercentageOfSpecificHandsThatAreSelected(generalHands);
    });
  };
};



// WEBPACK FOOTER //
// ./src/services/five-card-hands/FiveCardHands.js